import { useIntl } from 'react-intl';

import type { DeckPage as DeckPageData } from '../lib/decks.ts';
import { Alert, AlertDescription } from './ui/alert.tsx';
import { Button } from './ui/button.tsx';

export function DeckPageAction({
  page,
  joining,
  joinError,
  onJoin,
  signedIn,
}: {
  page: DeckPageData;
  joining: boolean;
  joinError: boolean;
  onJoin: (signUp: boolean) => void;
  signedIn: boolean;
}) {
  const intl = useIntl();
  return (
    <section className="grid min-h-[calc(100vh-7rem)] content-start gap-4">
      <h1 className="m-0 text-[clamp(2.5rem,8vw,5rem)] leading-[0.98] font-semibold tracking-[-0.045em]">
        {page.title}
      </h1>
      <p className="max-w-[38rem] whitespace-pre-wrap text-lg leading-relaxed text-muted-foreground">
        {page.description}
      </p>
      <div className="flex flex-wrap gap-3">
        <Button
          className="min-h-11 font-semibold"
          variant="default"
          disabled={joining}
          onClick={() => onJoin(false)}
          type="button"
        >
          {intl.formatMessage({
            id: signedIn ? 'web.deckPage.join' : 'web.deckPage.signInAndJoin',
          })}
        </Button>
        {!signedIn ? (
          <Button
            className="min-h-11 font-semibold"
            variant="secondary"
            disabled={joining}
            onClick={() => onJoin(true)}
            type="button"
          >
            {intl.formatMessage({ id: 'web.deckPage.signUpAndJoin' })}
          </Button>
        ) : null}
        {joinError ? (
          <Alert variant="destructive" className="w-full">
            <AlertDescription>
              {intl.formatMessage({ id: 'web.deckPage.joinError' })}
            </AlertDescription>
          </Alert>
        ) : null}
      </div>
    </section>
  );
}
